// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.incident-types-header-layout{background-color:#fff;margin:1rem;border-radius:1rem;padding:1rem;justify-content:space-between;box-sizing:border-box;box-shadow:0px 4px 4px rgba(0,0,0,.08)}.incident-types-body-layout{background-color:#fff;margin:1rem;border-radius:1rem;padding:1rem;box-sizing:border-box;box-shadow:0px 4px 4px rgba(0,0,0,.08)}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
